import { render, staticRenderFns } from "./fanjian.vue?vue&type=template&id=74758025&scoped=true"
import script from "./fanjian.vue?vue&type=script&lang=js"
export * from "./fanjian.vue?vue&type=script&lang=js"
import style0 from "./fanjian.vue?vue&type=style&index=0&id=74758025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74758025",
  null
  
)

export default component.exports